/*gloabl mod*/

!function($, mod) {

	var appId = "baseballcard";

	var helpers = {

		loadApp : function(symbol, container) {
			return mod.modules.widgetapi.load({
				widgets: {
					appId : appId,
					context : {
						Symbol : symbol
					}
				},
				success: function() {
					container
						.removeClass("loading")
						.css({
							"width" : "auto",
							"height" : "auto"
						});
				},
				container: container
			});
		},

		getPlaceholder : function() {
			return $("<div class='loading' />").height(50).width(200).append(
				$("<div class='loading-indicator' />")
			);
		},

		addEvents : function($el, symbol, placeholder) {
			$el.on("mouseenter", "", function() {
				// Store the data so we can clean up
				$el.data("symbolPreview", {
					query : helpers.loadApp(symbol, placeholder)
				});
			});

			$el.on("mouseleave", "", function() {
				// Clean up our data
				var data = $el.data("symbolPreview") || {};

				if (data.query) {
					data.query.abort();
				}

				// Remove the ref
				$el.data("symbolPreview", null);
			});
		},

		onHide : function(placeholder) {
			// Try to remove the baseball card inside the tooltip
			placeholder.find("div.widget").each(function(i, widget) {
				var $widget = $(widget);
				var instances = $widget.data("widget");

				if (instances) {
					instances.dispose();
				}

				$widget.remove();
			});
		}

	};

	var defaults = {
		html : true,
		animation : false,
		placement : "right",
		trigger : "hover",
		classes : [],
		delay : {
			show : 300,
			hide : 250
		},
		title : null
	};

	mod.modules.symbolPreview = function($el, symbol, options) {
		var params = $.extend(true, {}, defaults, options);

		// Always add a class so we'll know how to find the contents
		params.classes.push("baseballcard-tooltip")

		var placeholder = helpers.getPlaceholder();

		params.onHide = function() {
			helpers.onHide(placeholder);

			if (options.onHide) {
				options.onHide();
			}
		};

		// Get the placeholder and init the tooltip
		params.title = placeholder;
		$el.tooltip(params);

		// Attach the events that will show/hide the tooltip
		helpers.addEvents($el, symbol, placeholder);
	};

}(jQuery, window.mod);